/**
 * Empleados en la entrada (GEN-PX-012, spec §4.7). Lógica pura: qué se pinta de la lista que da el
 * kernel (GET /v1/entrada/empleados). Sin lógica de negocio: el kernel ya filtra a activos y quita
 * todo dato personal; aquí solo se ordena, se recorta a 8 y se elige el texto bajo el nombre.
 */

import { ROLE_LABELS } from './contract.js'

/** Máximo de personas visibles en la entrada (spec §4.7). */
export const MAX_EMPLEADOS = 8

/** Iniciales de la persona (máximo dos), en mayúscula. */
export const inicialesDe = (nombre) =>
  (nombre ?? '').trim().split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase()

/** Rol traducido; un rol que el front no conoce se muestra tal cual. */
export const rolTexto = (rol) => ROLE_LABELS[rol] ?? rol ?? ''

/** Texto bajo el nombre: el cargo si el directorio lo tiene; si no, el rol traducido. */
export const subtituloDe = (e) => (e.cargo ?? '').trim() || rolTexto(e.rol)

/**
 * Activas y por nombre. Con más de MAX_EMPLEADOS, las primeras MAX_EMPLEADOS por nombre: el kernel
 * aún no emite actividad por usuario, así que «las más activas» no se puede calcular (se dirá en cuanto
 * exista el dato). `todas` es el total, para el contador y para saber si hay enlace a Equipo.
 */
export function visiblesDe(empleados) {
  const activas = (Array.isArray(empleados) ? empleados : [])
    .filter(e => e && e.estado === 'activo' && (e.nombre ?? '').trim())
    .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }))
  return { visibles: activas.slice(0, MAX_EMPLEADOS), todas: activas.length }
}
